import type { DataOption } from '@/common.types'
import type { ScenarioModel } from '@/shared/generated'

import { map, paths, pipe, prop } from 'lodash/fp'

import { useOptimizationGroupQuery } from '@/entities/optimization-group'
import { useMainScenarioQuery, useScenariosQuery } from '@/entities/scenario'

import { toOption } from '@/shared/tools/utils'

export const useScenarioOptions = (optimizationGroupId: string) => {
	/**
	 * Queries
	 */
	const {
		data: optimizationGroupName,
		isLoading: isOptimizationGroupNameLoading,
	} = useOptimizationGroupQuery(optimizationGroupId, {
		select: prop('name'),
	})

	const { data: mainScenario, isLoading: isMainScenarioLoading } =
		useMainScenarioQuery<ScenarioModel>(optimizationGroupId)
	const { data: scenariosOptions, isLoading: isScenariosOptionsLoading } =
		useScenariosQuery<DataOption[]>(optimizationGroupId, {
			select: pipe(map(paths(['id', 'name'])), toOption),
		})

	return {
		options: scenariosOptions || [],
		defaultValue: mainScenario?.id,
		isLoading:
			isOptimizationGroupNameLoading ||
			isScenariosOptionsLoading ||
			isMainScenarioLoading,
		optimizationGroupName: optimizationGroupName || '',
	}
}
